export interface TimeslotDate {
  date: Date;
  selected?: boolean;
  price?: number;
}
